import { styled } from "styled-system/jsx";
import { JsxStyleProps, RecipeVariantProps } from "styled-system/types";
import { cva } from "styled-system/css";
import { MediaImage } from "iconoir-react";

const imagePlaceholderStyles = cva({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "full",
    h: "full",
    borderRadius: "100",
  },
  variants: {
    variant: {
      default: {},
      warning: {},
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const variantColors = {
  default: { bg: "#E6E4D9", icon: "#B7B5AC" },
  warning: { bg: "#FAEEC6", icon: "#AD8301" },
} as const;

type ImagePlaceholderVariants = NonNullable<
  RecipeVariantProps<typeof imagePlaceholderStyles>
>;

export type ImagePlaceholderProps = JsxStyleProps &
  ImagePlaceholderVariants & {
    className?: string;
    iconSize?: number;
  };

const Base = styled("div", imagePlaceholderStyles);

export const ImagePlaceholder = ({
  variant = "default",
  iconSize = 24,
  ...rest
}: ImagePlaceholderProps) => {
  const colors = variantColors[variant];
  return (
    <Base variant={variant} style={{ background: colors.bg }} {...rest}>
      <MediaImage width={iconSize} height={iconSize} color={colors.icon} />
    </Base>
  );
};
